/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ResendEventNotificationRequestData { 
    /**
     * Id события
     */
    id?: string;
    /**
     * Id пользователей, кому отправить
     */
    sendTo?: Array<string>;
    /**
     * Признак повторного уведомления со словами о напоминании события
     */
    isNotify?: boolean;
}

